var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"app-main"},[_c('keep-alive',{attrs:{"include":_vm.cachedViews}},[(_vm.$route.meta.keepAlive)?_c('router-view'):_vm._e()],1),(!_vm.$route.meta.keepAlive)?_c('router-view'):_vm._e(),_c('iframe-toggle')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }